import React, { Component, Fragment } from 'react'
import { Button, ButtonGroup, ButtonToolbar, Navbar, Nav, NavItem, NavbarToggler, Collapse, Container, NavLink, NavbarBrand} from 'reactstrap';
import '../App.css';
import LoggedContext from '../BusinessObjects/LoggedContext'


interface IEsaedroMenuProps {
  name:string;
  className:string;
  onClick?(menuItemId: any): void;
  items: any[]
}


export default class EsaedroMenu extends Component<IEsaedroMenuProps, any> {
  
  constructor(props: IEsaedroMenuProps){
      super(props);

      this.state = {
          collapsed: true
      };
  }

  toggleNavbar = () => {
    this.setState({
        collapsed: !this.state.collapsed
    });
  }

  menuItemSelected = (e: any) => {
    if (this.props.onClick!=undefined) {
      this.props.onClick(e.target.value)
    }
  }

  render() {

    if (this.props.items.length) {

      // Divido i sottomenu dai menu "Risorsa" 
      let sottomenu: any[] = []
      let menuRisorse: any[] = []
      if (this.props.items) {
        this.props.items.map((menuVoice: any) => {
          if (menuVoice.Resource_ID) menuRisorse.push(menuVoice)
          else sottomenu.push(menuVoice)
        })
      }
      const sottomenuElements = sottomenu.length
        ? sottomenu.map((menuVoice: any, i) => {
            return (
              <Button color="warning" block value={menuVoice.Id} onClick={this.menuItemSelected} key={i}><i className="fa fa-level-down"></i> {menuVoice.Description}</Button>
            )
          })
        : undefined

      const sottomenuIntestazione = sottomenuElements
        ? <Navbar>Seleziona un Sottomenu: </Navbar>
        : undefined

      const menuRisorseElements = menuRisorse.length
        ? menuRisorse.map((menuVoice: any, i) => {
            return (
              <Button color="primary" block value={menuVoice.Id} onClick={this.menuItemSelected} key={i}> <i className="fa fa-search"></i> {menuVoice.Description}</Button>
            )
          })
        : undefined

      const risorseIntestazione = menuRisorseElements
        ? <Navbar>Seleziona una Risorsa: </Navbar>
        : undefined

      if (!sottomenuElements && !menuRisorseElements) return (
        <div className="form-group">
          Errore: non ci sono elementi da visualizzare...
        </div>
      )

      return (
        <Fragment>
          {sottomenuIntestazione}
          <Navbar className="navbar-expand-sm navbar-toggleable-sm navbar-light">
            <Container>
              <NavbarToggler onClick={this.toggleNavbar}/>
              <Collapse className="d-sm-flex flex-sm-row" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav row">
                {sottomenuElements}
              </ul>
              </Collapse>
            </Container>
          </Navbar>
          {risorseIntestazione}
          <Navbar className="navbar-expand-sm navbar-toggleable-sm navbar-light">
            <Container>
              <NavbarToggler onClick={this.toggleNavbar}/>
              <Collapse className="d-sm-flex flex-sm-row" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav row">
                {menuRisorseElements}
              </ul>
              </Collapse>
            </Container>
          </Navbar>
        </Fragment>
      )
    }
    else return (
      <div className={this.props.className?this.props.className:"form-group"}>
      </div>
    )
  }
}
  